import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, ListGroup, ListGroupItem } from 'react-bootstrap';
import ScenarioViewModeData from './ScenarioViewModeData.react';

import { ScenarioPropTypes } from '../util/helpers/SharedPropTypes';
import { displayAsMoney } from '../util/helpers/Numbers';
import { StatusIconCell } from './CellFormatters.react';
import { capitalize } from '../util/helpers/Strings';

function getStartedAt(scenario) {
  if ((scenario.lastRun || {}).startedAt) {
    return scenario.lastRun.startedAt.format('D MMM, h:mm A');
  }
  return 'Never';
}

function displaySubsetInformation(scenario, queries) {
  if (scenario.parameters.targetListSubsetMode) {
    return `${queries.targetListSubsetUniverse} on mode: ${capitalize(scenario.parameters.targetListSubsetMode)}`;
  }
  return null;
}

const ScenarioViewData = ({ scenario, queries }) => (
  <div className='scenario-data'>
    <Row className='scenario-topline'>
      <Col sm={6}>
        <ListGroup>
          <ListGroupItem>
            <strong>Status:</strong> {capitalize(scenario.status)} <StatusIconCell cellData={scenario.status} size='lg' />
          </ListGroupItem>

          <ListGroupItem><strong>Last Run:</strong> {getStartedAt(scenario)}</ListGroupItem>
          <ListGroupItem>
            <strong>Total Budget:</strong> {displayAsMoney(scenario.parameters.totalBudget)}
          </ListGroupItem>
        </ListGroup>
      </Col>
      <Col sm={6}>
        <ListGroup>
          <ListGroupItem><strong>Universe:</strong> {queries.targetUniverse}</ListGroupItem>
          <ListGroupItem className={queries.upliftScore ? '' : 'bg-muted'}><strong>Impact Scores:</strong> {queries.upliftScore}</ListGroupItem>
          <ListGroupItem className={queries.targetListSubsetUniverse ? '' : 'bg-muted'}><strong>Subset Universe:</strong> {displaySubsetInformation(scenario, queries)}</ListGroupItem>
        </ListGroup>
      </Col>
    </Row>

    <Row className='scenario-modes'>
      <Col sm={12}>
        <ScenarioViewModeData modes={scenario.parameters.modes} />
      </Col>
    </Row>
  </div>
);

ScenarioViewData.propTypes = {
  scenario: ScenarioPropTypes,
  queries: PropTypes.shape({
    targetUniverse: PropTypes.string,
    upliftScore: PropTypes.string,
  }),
};

export default ScenarioViewData;
